module.exports = __webpack_public_path__ + "img/beyond.dff50302.png";